import { configureStore } from "@reduxjs/toolkit"
import rootReducer from "./reducers"

const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV === "development", // RTK handles this automatically
  preloadedState: {} // your initialState
})

export default store
